/*
 * Brand test: sold-out checkout.
 *
 * "Til kassen" (snippets/cart-summary.liquid, cart page and drawer) never opens Shopify's
 * checkout. On click it reads the cart, publishes the custom event
 * `udsolgt_initiate_checkout` with the cart, and opens the sold-out page.
 * The sign-up form on that page (sections/udsolgt.liquid) tags the customer
 * `udsolgt-venteliste` + the product handles in the cart. `udsolgt_lead` is published with the
 * same cart when the page comes back with the success message (form.posted_successfully?),
 * not on submit: a failed submit sends nothing, and a sessionStorage key per cart stops a reload
 * of the success page from sending it twice.
 * Links to "#cookie-indstillinger" open Shopify's cookie preferences when the banner API is there.
 *
 * A Customer Events custom pixel maps the two events to InitiateCheckout and Lead.
 * Loaded once from layout/theme.liquid; listeners sit on document, so buttons that the
 * cart drawer re-renders keep working.
 */
(function () {
  if (window.__udsolgtBound) return;
  window.__udsolgtBound = true;

  var LIST_TAG = 'udsolgt-venteliste';
  var MAX_HANDLE_TAGS = 10;
  var CART_TIMEOUT_MS = 3000;
  /* Gives the web-pixel sandbox a moment to take the event before the page unloads. */
  var PUBLISH_GRACE_MS = 300;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof r === 'string' && r.charAt(0) === '/' ? r : '/';
  }

  function soldOutUrl() {
    return root() + 'pages/udsolgt';
  }

  function getCart() {
    var request = fetch(root() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart.js ' + response.status);
      return response.json();
    });
    var timeout = new Promise(function (_, reject) {
      setTimeout(function () {
        reject(new Error('cart.js timeout'));
      }, CART_TIMEOUT_MS);
    });
    return Promise.race([request, timeout]);
  }

  function cartPayload(cart) {
    var items = (cart && cart.items) || [];
    return {
      value: cart && typeof cart.total_price === 'number' ? cart.total_price / 100 : 0,
      currency: 'DKK',
      content_ids: items.map(function (item) {
        return String(item.variant_id);
      }),
      contents: items.map(function (item) {
        return { id: String(item.variant_id), quantity: item.quantity };
      }),
      num_items: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
    };
  }

  function publish(name, payload) {
    try {
      window.Shopify.analytics.publish(name, payload);
      return true;
    } catch (error) {
      /* No analytics on this page view (e.g. theme editor): carry on without the event. */
      return false;
    }
  }

  function cartTags(cart) {
    var tags = [LIST_TAG];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length && tags.length < MAX_HANDLE_TAGS + 1; i++) {
      var handle = String(items[i].handle || '')
        .replace(/,/g, '')
        .trim()
        .slice(0, 100);
      if (handle && tags.indexOf(handle) === -1) tags.push(handle);
    }
    return tags.join(', ');
  }

  /* "Til kassen": capture phase, so nothing else in the drawer can act on the click first. */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest('[data-udsolgt-checkout]') : null;
      if (!button) return;
      event.preventDefault();
      if (button.disabled || button.getAttribute('data-udsolgt-busy') === 'true') return;
      button.setAttribute('data-udsolgt-busy', 'true');
      button.setAttribute('aria-busy', 'true');

      getCart()
        .then(function (cart) {
          publish('udsolgt_initiate_checkout', cartPayload(cart));
        })
        .catch(function () {
          /* Cart unreadable: no event, but the visitor still reaches the sold-out page. */
        })
        .then(function () {
          setTimeout(function () {
            window.location.href = soldOutUrl();
          }, PUBLISH_GRACE_MS);
        });
    },
    true
  );

  /* Back button from the sold-out page restores this page from cache: free the button again. */
  window.addEventListener('pageshow', function () {
    var busy = document.querySelectorAll('[data-udsolgt-busy]');
    for (var i = 0; i < busy.length; i++) {
      busy[i].removeAttribute('data-udsolgt-busy');
      busy[i].removeAttribute('aria-busy');
    }
  });

  /*
   * Sign-up on /pages/udsolgt. The submit is never held back or re-sent (Shopify wires its own
   * bot protection onto customer forms), so the cart is read before the visitor submits: the
   * page renders it server-side, and /cart.js refreshes it on load and when the email field gets
   * focus. On submit: write the tags and let the form go. udsolgt_lead goes out from the success
   * render (see publishLeadOnSuccess).
   */
  var latestCart = null;

  function readRenderedCart(form) {
    var node = form.querySelector('script[data-udsolgt-cart]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function refreshCart() {
    getCart()
      .then(function (cart) {
        latestCart = cart;
        var forms = document.querySelectorAll('form[data-udsolgt-form]');
        for (var i = 0; i < forms.length; i++) {
          var tagsInput = forms[i].querySelector('input[name="contact[tags]"]');
          if (tagsInput) tagsInput.value = cartTags(cart);
        }
      })
      .catch(function () {
        /* Keep the server-rendered cart and tags. */
      });
  }

  function cartSignature(cart) {
    var items = (cart && cart.items) || [];
    var parts = [];
    for (var i = 0; i < items.length; i++) parts.push(items[i].variant_id + 'x' + items[i].quantity);
    return parts.join('-') + '|' + (cart && cart.total_price);
  }

  function readFlag(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeFlag(key) {
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      /* Storage blocked: the event can repeat on a reload, nothing else breaks. */
    }
  }

  /* The page came back with the success message: the sign-up went through. One event per cart per session. */
  function publishLeadOnSuccess(form) {
    if (!form.querySelector('[data-udsolgt-success]')) return;
    var cart = readRenderedCart(form);
    var key = 'udsolgt_lead:' + cartSignature(cart);
    if (readFlag(key)) return;
    function attempt() {
      if (readFlag(key)) return true;
      if (publish('udsolgt_lead', cartPayload(cart))) {
        writeFlag(key);
        return true;
      }
      return false;
    }
    if (!attempt() && document.readyState !== 'complete') {
      /* Analytics not ready yet: try once more when the page has loaded. */
      window.addEventListener('load', attempt, { once: true });
    }
  }

  function initSignupForms() {
    var forms = document.querySelectorAll('form[data-udsolgt-form]');
    if (!forms.length) return;
    latestCart = readRenderedCart(forms[0]);
    for (var i = 0; i < forms.length; i++) publishLeadOnSuccess(forms[i]);
    if (!forms[0].querySelector('[data-udsolgt-success]')) refreshCart();
  }

  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('form[data-udsolgt-form]') && target.type === 'email') {
      refreshCart();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-udsolgt-form]')) return;
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    var cart = latestCart || readRenderedCart(form);
    if (tagsInput && cart) tagsInput.value = cartTags(cart);
  });

  /* "Cookieindstillinger" links (footer, privatlivspolitik, cookiepolitik): open Shopify's preferences. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('a[href$="#cookie-indstillinger"]') : null;
    if (!link) return;
    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return;
    event.preventDefault();
    try {
      var result = banner.showPreferences();
      if (result && typeof result.catch === 'function') {
        result.catch(function () {
          window.location.href = link.href;
        });
      }
    } catch (error) {
      window.location.href = link.href;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSignupForms);
  } else {
    initSignupForms();
  }
})();
